import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { recordScreenVisit as apiRecordScreenVisit } from '../api';
import { useAuth } from '../auth/useAuth';
import { labelForPath } from '../lib/screenLabel';

export function usePageTracking(): void {
  const { pathname } = useLocation();
  const { isAuthenticated, initializing } = useAuth();

  useEffect(() => {
    // Skip until auth is resolved — the token is in-memory only, so on a fresh
    // page load it doesn't exist yet and the request would 401.
    if (initializing || !isAuthenticated) return;
    // Fire-and-forget: network errors are silently swallowed so tracking never
    // blocks navigation or disrupts the UI.
    void apiRecordScreenVisit(labelForPath(pathname)).catch(() => undefined);
  }, [pathname, isAuthenticated, initializing]);
}
